<div class="container">
  <section class="main">
    <header class="header">
      <mat-icon>donut_large</mat-icon><span>AI Sales Coach</span>
    </header>
    <div class="content">
      <h1>パスキーの登録</h1>
      <p>
        端末の生体認証やセキュリティキーを使って、パスキーを登録してください。
      </p>
      @if (!supported) {
        <p role="alert">
          このブラウザではパスキーを利用できません。対応ブラウザをご利用ください。
        </p>
      }
      <form [formGroup]="form" (ngSubmit)="submit()">
        <label for="display-name">表示名</label>
        <input
          id="display-name"
          maxlength="64"
          [formControl]="displayName"
          autocomplete="off"
        />
        @if (errorMessage) {
          <p role="alert">{{ errorMessage }}</p>
        }
        <button
          rectangle
          [disabled]="busy || !supported || !canRetry || displayName.invalid"
          type="submit"
        >
          {{
            busy
              ? '処理中…'
              : errorMessage && canRetry
                ? '再試行'
                : 'パスキーを登録'
          }}
        </button>
      </form>
      <button rectangle variant="secondary" [disabled]="busy" (click)="back()">
        戻る
      </button>
    </div>
  </section>
</div>
